import { AntButton } from '@/common/ant-components/AntButton';
import DraggableModal from '@/common/ant-components/DraggableModal';
import { useNavigationHistory } from '@/common/navigation-history';
import { returnLinks } from '@/common/navigation-history/data';
import ItemForm from '@/components/forms/master/inventory/item/ItemForm';
import { useTransactionContext } from '@/context/TransactionContext';
import useAppData from '@/hooks/useAppData';
import {
  isDiamondStoneRow,
  isDiamondStoneType,
  useDiamondStoneModal,
} from '@/pages/transaction/reuse/helpers/diamondStone';
import {
  formatNumber,
  formatNumberWithComma,
} from '@/utils/formula/CodeWindow';
import GlobalFormModal from '@/utils/modal/GlobalFormModal';
import GlobalModal from '@/utils/modal/Modal';
import { BACK_ROUTES_PATH } from '@/utils/routerPath/route-path';
import CustomSelect from '@/utils/search/Search';
import { DeleteFilled, PlusOutlined } from '@ant-design/icons';
import { Form, Input, Modal, Spin, Table } from 'antd';
import Cookies from 'js-cookie';
import { createRef, useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const DynamicTransactionTable = ({
  loading,
  columns,
  tableData,
  handleAddRow,
  handleItemSelect,
  renderSummary,
  showItemList,
  baseUrl,
  editUrl,
  handlePurchaseItemClick,
  refreshTable,
  form,
  from,
  showDisabledData,
  selectRefs,
  selectRef,
  discountRef,
  setIsReceiveCodeWindowVisible,
  selectedData,
  setSelectedReceiveId,
  onItemSearch,
  onItemPopupScroll,
  onItemOpenChange,
  itemFetching = false,
  onRowOpen,
  enableDiamondStone = false,
}) => {
  const {
    selectedItems,
    setSelectedItems,
    selectedRowKey,
    // setHiddenValueChange,
    setpurchaseTableData,
    hiddenValueChange,
    setSelectedRowKey,
  } = useTransactionContext();
  const navigate = useNavigate();
  const { openDiamondStone, openDiamondStoneForRow } = useDiamondStoneModal();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const formD = Form.useFormInstance();

  const firstRowRef = useRef(null);
  const lastRowRef = useRef(null);

  const [isMessageModalVisible, setIsMessageModalVisible] = useState(false);
  const [deletereferenceId, setDeleteReferenceId] = useState({});
  const primaryCalculationType = Cookies.get('primaryCalculationType');

  const [scrollY, setScrollY] = useState(400); // Default height

  const location = useLocation();

  const isOpeningStock =
    location?.pathname?.includes('/opening/stock/create/') ||
    location?.pathname?.includes('/opening/stock/edit/');

  const isPurchase = from === 'purchase';

  const isReciveFromSales = [
    '/sales/edit/',
    '/sales/create/',
    '/sales/order/create/',
    '/sales/order/edit/',
    '/sales/return/create/',
    '/sales/return/edit/',
  ].some((path) => location.pathname.includes(path));

  useEffect(() => {
    // Function to calculate dynamic table height
    const updateTableHeight = () => {
      const windowHeight = window.innerHeight;
      const tableOffset = isOpeningStock ? 300 : isPurchase ? 470 : 440; // Adjust based on header, padding, etc.

      const updatedHeight = Math.max(windowHeight - tableOffset, 100);
      setScrollY(updatedHeight);
    };
    updateTableHeight(); // Initial height set
    window.addEventListener('resize', updateTableHeight); // Update on resize
    return () => window.removeEventListener('resize', updateTableHeight);
  }, []);

  const handleAddClick = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  const history = useNavigationHistory();

  const [yesNo, setYesNo] = useState(false);

  const noRef = useRef();
  const yesRef = useRef();

  const { app } = useAppData();

  const itemListWithSavedItems = (() => {
    const rows = showItemList || [];
    const known = new Set(rows.map((item) => item?.referenceId));
    const saved = [];
    (tableData || []).forEach((row) => {
      const itemId =
        row?.item || row?.itemId || row?.finalData?.detailsJson?.[0]?.itemId;
      if (!itemId || !row?.itemName || known.has(itemId)) return;
      known.add(itemId);
      saved.push({
        referenceId: itemId,
        name: row.itemName,
        itemTypeName: row?.itemTypeName || row?.itemType,
        isSavedRowItem: true,
      });
    });
    return saved.length ? [...saved, ...rows] : rows;
  })();

  const modifiedColumns = columns?.map((column) => {
    switch (column?.key) {
      case 'SN':
        return {
          ...column,
          render: (_, __, index) => index + 1,
        };
      case 'item':
        return {
          ...column,
          render: (_, rowData, index) => {
            formD?.setFieldValue(
              `item_name${index}`,
              rowData?.item ||
                rowData?.itemName ||
                (index > 0 ? tableData?.[index - 1]?.itemName : undefined),
            );

            const currentItemName = tableData?.[index - 1]?.itemName;

            const sortedItemList = [
              ...itemListWithSavedItems.filter(
                (item) => item.name === currentItemName,
              ),
              ...itemListWithSavedItems.filter(
                (item) => item.name !== currentItemName,
              ),
            ];

            const isFirstIndex = index === 0;

            if (!selectRefs.current[index]) {
              selectRefs.current[index] = createRef();
            }

            return (
              <Form.Item
                name={`item_name${index}`}
                noStyle
                rules={[
                  {
                    required: isFirstIndex,
                    message: '',
                  },
                ]}
              >
                <CustomSelect
                  style={{ width: '100%' }}
                  placeholder="Select Item"
                  selectRef={selectRefs.current[index]}
                  value={rowData?.item || rowData?.itemName || undefined}
                  onChange={(value, option, e) => {
                    handleItemSelect(value, index, option?.itemName);
                    showDisabledData &&
                      setSelectedItems((prevSelected) => [
                        ...prevSelected,
                        value,
                      ]);
                    if (
                      enableDiamondStone &&
                      isDiamondStoneType(option?.itemType)
                    ) {
                      openDiamondStone(
                        rowData?.id || rowData?.codeWindowId,
                        option,
                      );
                      return;
                    }
                    isReciveFromSales && setIsReceiveCodeWindowVisible(true);
                    isReciveFromSales &&
                      // setSelectedReceiveId &&
                      setSelectedReceiveId(
                        rowData?.id || rowData?.codeWindowId,
                      );
                    !isReciveFromSales &&
                      navigate(
                        `/${baseUrl}/${rowData?.id || rowData?.codeWindowId}`,
                      );
                  }}
                  onKeyDown={(e) => {
                    if (e.code === 'ArrowLeft' && index === 0) {
                      e.preventDefault();
                      selectRef.current?.focus();
                    }
                    if (
                      e.key === '+' ||
                      e.code === 'Equal' ||
                      e.code === 'NumpadAdd'
                    ) {
                      e.preventDefault();
                      handleAddClick();
                    }
                    if (e.altKey && e.code === 'KeyD') {
                      e.preventDefault();
                      discountRef?.current?.focus();
                    }
                    if (e.code === 'F10') {
                      e.preventDefault();
                      formD?.submit();
                    }
                    if (e.altKey && e.code === 'ArrowUp') {
                      firstRowRef.current.focus();
                    }
                    if (e.altKey && e.code === 'ArrowDown') {
                      lastRowRef.current.focus();
                    }

                    if (e.code === 'Escape') {
                      e.preventDefault();
                      if (!hiddenValueChange) {
                        target
                          ? navigate(-1)
                          : isRedirectPath
                            ? navigate(isRedirectPath)
                            : navigate(-1);
                        return;
                      } else {
                        setYesNo(true);
                        setTimeout(() => {
                          noRef?.current?.focus();
                        }, 100);
                      }
                    }
                  }}
                  disabled={
                    !!rowData?.itemId ||
                    !!rowData?.itemName ||
                    (location.pathname.includes('/receive/refine/')
                      ? !selectedData?.ledger?.length
                      : false)
                  }
                  options={sortedItemList?.map((item) => ({
                    key: item.referenceId,
                    label: item.name,
                    value: item.referenceId,
                    itemName: item.name,
                    itemType: item?.typeName || item?.itemTypeName,
                    disabled:
                      !item?.isSavedRowItem &&
                      item?.barCode !== 'yes' &&
                      selectedItems.includes(item.referenceId),
                  }))}
                  filterSort={() => {}}
                  {...(onItemSearch && {
                    onSearch: onItemSearch,
                    onPopupScroll: onItemPopupScroll,
                    onDropdownVisibleChange: onItemOpenChange,
                    filterOption: false,
                    loading: itemFetching,
                    notFoundContent: itemFetching ? (
                      <Spin size="small" />
                    ) : undefined,
                  })}
                  onAddClick={handleAddClick}
                />
              </Form.Item>
            );
          },
        };

      case 'code':
        return {
          ...column,
          render: (_, rowData, index) => {
            const itemBarcodePrefix = rowData?.itemBarcodePrefix;
            const itemCode = rowData?.itemCode || rowData?.code || '';
            const itemCodeToUse = itemBarcodePrefix
              ? `${itemBarcodePrefix}${itemCode}`
              : itemCode;
            formD.setFieldsValue({
              [`item_code${index}`]: itemCodeToUse || '',
            });

            return (
              <Form.Item name={`item_code${index}`} noStyle>
                <Input
                  // selectRef={}
                  // value={rowData.itemCode || rowData.code}
                  disabled={true}
                  onInput={(e) =>
                    (e.target.value = e.target.value.toUpperCase())
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onChange={(e) => {
                    formD.setFieldsValue({
                      [`item_code${index}`]: e.target.value,
                    });
                    setpurchaseTableData((prevData) => {
                      return prevData.map((row) => {
                        if (
                          rowData?.id === row?.id ||
                          (rowData?.itemDetailId !== undefined &&
                            rowData?.itemDetailId === row?.itemDetailId)
                        ) {
                          return {
                            ...row,
                            code: e.target.value,
                            finalData: {
                              ...row?.finalData,
                              detailsJson: [
                                {
                                  ...row?.finalData?.detailsJson[0],
                                  code: e.target.value,
                                },
                              ],
                            },
                          };
                        }
                        return row;
                      });
                    });
                  }}
                  onKeyDown={(e) => {
                    if (e.code === 'Escape') {
                      e.preventDefault();
                      if (!hiddenValueChange) {
                        target
                          ? navigate(-1)
                          : isRedirectPath
                            ? navigate(isRedirectPath)
                            : navigate(-1);
                        return;
                      } else {
                        setYesNo(true);
                        setTimeout(() => {
                          noRef?.current?.focus();
                        }, 100);
                      }
                    }
                  }}
                />
              </Form.Item>
            );
          },
        };
      case 'purity':
        return {
          ...column,
          render: (_, rowData) =>
            rowData?.purity
              ? Number((rowData?.purity * 24) / 100)?.toLocaleString()
              : 0,
        };

      case 'gwt':
        return {
          ...column,
          render: (_, rowData) => rowData?.grossWeight || 0,
        };
      case 'diamondWeight':
        return {
          ...column,
          render: (_, rowData) => rowData?.diamondWeight || 0,
        };

      case 'stoneWeight':
        return {
          ...column,
          render: (_, rowData) => rowData?.stoneWeight || 0,
        };

      case 'nwt':
        return {
          ...column,
          render: (_, rowData) =>
            Number(rowData?.netWeight || 0)?.toFixed(1) || 0,
        };

      case 'wtInTola':
        return {
          ...column,
          render: (_, rowData) => {
            const netWeight = rowData?.netWeight;
            let value = 0;
            value =
              netWeight !== undefined && netWeight !== null
                ? primaryCalculationType === 'lal'
                  ? Number(netWeight) * 0.11664
                  : Number(netWeight) / 0.11664
                : 0;
            value = formatNumber(value, 3);
            return isNaN(value) ? 0 : value;
          },
        };

      case 'rate':
        return {
          ...column,
          render: (_, rowData) => formatNumberWithComma(rowData?.rate) || 0,
        };
      case 'ratePerPurity':
        return {
          ...column,
          render: (_, rowData) =>
            formatNumberWithComma(rowData?.ratePerPurity) || 0,
        };

      case 'wastage':
        return {
          ...column,
          render: (_, rowData) => rowData?.wastageWeight || 0,
        };

      case 'pureWeight':
        return {
          ...column,
          render: (_, rowData) => rowData?.pureWeight || 0,
        };
      case 'netWithWastage':
        return {
          ...column,
          render: (_, rowData) => rowData?.netWithWastage || 0,
        };

      case 'amount':
        return {
          ...column,
          render: (_, rowData) =>
            formatNumberWithComma(rowData?.makingAmount) || 0,
        };

      case 'netAmount':
        return {
          ...column,
          render: (_, rowData) =>
            formatNumberWithComma(rowData?.netAmount) || 0,
        };
      case 'action':
        return {
          ...column,

          className: 'tw-bg-[transparent]',

          fixed: 'right',
          width: 45,

          render: (_, rowData, index) => (
            <div className="tw-flex tw-justify-center">
              <div
                className="ant-action tw-flex"
                onClick={(e) => e.stopPropagation()}
              >
                {from !== 'purchase' && (
                  <div
                    className="ant-button-edit"
                    onClick={() => {
                      handleAddRow();
                    }}
                  >
                    <Link size="medium" className="edit">
                      <PlusOutlined />
                    </Link>
                  </div>
                )}
                {/* <div></div> */}
                <div
                  className="ant-button-delete"
                  onClick={() => {
                    if (
                      rowData?.code?.toLowerCase() ===
                      selectedRowKey?.toLowerCase()
                    ) {
                      setSelectedRowKey(null);
                    }
                    setDeleteReferenceId({
                      index,
                      id: rowData?.id || rowData?.codeWindowId,
                      item:
                        rowData?.item ||
                        rowData?.itemId ||
                        rowData?.finalData?.detailsJson[0]?.itemId,
                    });
                    setIsMessageModalVisible(true);
                  }}
                >
                  <Link size="medium" className="delete">
                    <DeleteFilled />
                  </Link>
                </div>
              </div>
            </div>
          ),
        };

      default:
        return column;
    }
  });

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e?.altKey && (e.code === 'ArrowUp' || e.code === 'Home')) {
        e.preventDefault();
        if (firstRowRef.current) {
          firstRowRef.current.focus();
        }
      } else if (e?.altKey && (e.code === 'ArrowDown' || e.code === 'End')) {
        e.preventDefault();
        if (lastRowRef.current) {
          lastRowRef.current.focus();
        }
      } else if (e.code === 'ArrowRight') {
        requestAnimationFrame(() => {
          noRef?.current?.focus();
        });
      } else if (e.code === 'ArrowLeft') {
        requestAnimationFrame(() => {
          yesRef?.current?.focus();
        });
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const state = location?.state || null;

  const { ledgerDetails, stockDetails } = useTransactionContext();

  const stateData = ledgerDetails
    ? ledgerDetails
    : stockDetails?.code
      ? stockDetails
      : state;

  const exclude = [
    '/codewindow',
    '/sales/return/code/window',
    '/purchase/return/code/window',
    '/transaction/sales/create/',
    '/transaction/sales/edit/',
    '/ledger-details/reports/',
    '/stock/detail/report/',
    '/stock/ledger/report/',
    '/ledger/reports/',
    '/stock-summary/reports/',
  ];

  const isExcluded = exclude?.some((path) =>
    location?.pathname?.startsWith(path),
  );

  const target = isExcluded
    ? null
    : [...history]
        .reverse()
        .find(
          (path, index) =>
            index === 1 &&
            returnLinks?.some((prefix) => path.startsWith(prefix)),
        );

  const isRedirectPath = BACK_ROUTES_PATH?.find(
    (item) =>
      item?.route === location?.pathname ||
      location?.pathname.startsWith(item.route),
  )?.route_to_redirect;

  return (
    <>
      <DraggableModal
        open={yesNo}
        onCancel={() => setYesNo(false)}
        width={400}
        title={'Are you sure you want to exit?'}
        footer={
          <div className="tw-flex tw-justify-end tw-gap-x-3">
            <div>
              <AntButton
                ref={yesRef}
                onClick={() => {
                  target
                    ? navigate(target, {
                        state: {
                          ...stateData,
                        },
                      })
                    : isRedirectPath
                      ? navigate(isRedirectPath, {
                          state: {
                            ...stateData,
                          },
                        })
                      : navigate(-1);
                }}
              >
                Yes
              </AntButton>
            </div>
            <div>
              <AntButton
                color="red"
                ref={noRef}
                onClick={() => {
                  setYesNo(false);
                }}
              >
                No
              </AntButton>
            </div>
          </div>
        }
      ></DraggableModal>

      <Table
        bordered
        loading={loading}
        columns={modifiedColumns}
        onRow={(rowData, index) => {
          return {
            tabIndex: index,
            ref:
              index === 0
                ? firstRowRef
                : index === tableData.length - 1
                  ? lastRowRef
                  : null,
            onClick: () => {
              if (rowData?.item || rowData?.itemName) {
                setSelectedRowKey(rowData?.code);
                if (enableDiamondStone && isDiamondStoneRow(rowData)) {
                  openDiamondStoneForRow(rowData);
                  return;
                }
                if (onRowOpen) {
                  onRowOpen(rowData);
                  return;
                }
                // setHiddenValueChange(true);
                isReciveFromSales && setIsReceiveCodeWindowVisible(true);
                isReciveFromSales &&
                  setSelectedReceiveId(rowData?.id || rowData?.codeWindowId);
                !isReciveFromSales &&
                  navigate(
                    `/${editUrl}/${rowData?.id || rowData?.codeWindowId}`,
                  );
              }
            },
            onKeyDown: (e) => {
              try {
                if (e.key === 'ArrowUp' && index > 0) e.preventDefault();
                e.target.previousSibling.focus();
                if (e.key === 'ArrowDown' && index < tableData?.length)
                  e.preventDefault();
                e.target.nextSibling.focus();
              } catch (err) {}
            },
          };
        }}
        rowClassName={(record) => {
          if (
            selectedRowKey &&
            record.code?.toLowerCase() === selectedRowKey.toLowerCase()
          ) {
            // return `tw-bg-[#d9fdd3] selectedRow tw-cursor-pointer ${record.vatPercent === 13 ? 'tw-text-amber-600 tw-font-[700]' : ''}`;
            return `tw-bg-[#d9fdd3] selectedRow tw-cursor-pointer`;
          }

          // if (record.vatPercent === 13) {
          //   return 'tw-text-amber-600 tw-cursor-pointer tw-font-[700]';
          // }

          // if (record.grossWeight) {
          //   return 'tw-cursor-pointer';
          // }

          return '';
        }}
        dataSource={tableData}
        style={{ textAlign: 'center', padding: '0 15px' }}
        pagination={false}
        scroll={{ x: 'max-content', y: scrollY }}
        // scroll={{ x: 'max-content', y: '35vh' }}
        summary={() => renderSummary}
      />
      <GlobalModal
        isVisible={isMessageModalVisible}
        type={'delete'}
        onConfirm={() => {
          handlePurchaseItemClick(
            deletereferenceId?.id,
            deletereferenceId.item,
            setIsMessageModalVisible,
          );
        }}
        onClose={() => {
          setIsMessageModalVisible(false);
        }}
      />
      <GlobalFormModal
        title="Create Item"
        isVisible={isModalVisible}
        onClose={() => {
          closeModal();
        }}
      >
        <ItemForm
          onClose={() => {
            closeModal();
          }}
          refreshTable={refreshTable}
        />
      </GlobalFormModal>
    </>
  );
};

export default DynamicTransactionTable;
